var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 57,
    viewBox: "0 0 24 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.9374,
    width: 56.5868,
    height: 23.2877,
    transform: "rotate(90 23.9374 0)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_557_646",
    transform: "translate(0.294231) scale(0.00428686 0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_557_646",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAlZJREFUeF7t3b0uREEYxvE5RC3ElXAR9PQ+boKOjovQ6SS4AIWWa5Fga8vIKSQistnkxft8vNtuZubk/9vZac7uGVq9UgsMqavX4q0Akj8EBVAAyQWSl68dUADJBZKXrx1QAMkFkpevHVAAyQWSl4fbAS/XB0fT99e7tZ2Lh+Q2/7I8FMDzzcFJ6/24tTZZ6Itby9vn9/9SIXERGIAv8T9zWCBAAPwQ3wYhHWBGfAuEVIDxwO2tn87xFTx5e59uKh7MuQBX++t9aLettdV5EBQP5lSAMfqLOUI6gDsCBIAzAgyAKwIUgCMCHIAbAiSAEwIsgAsCNIADAjyAOgIFgDICDYAqAhWAIgIdgBoCJYASAi2ACgI1gAICPQA7ggQAM4IMACuCFAAjghwAG4IkABOCLAALgjQAA4I8ADqCBQAygg0AKoIVACKCHQAagiXA4+XuxtLS4m3vfWWe2+L/8rcJdgBI8Ud8KwC0+FYAiPFtAFDjWwAgx5cHQI8vDcAQXxaAJb4kAFN8OQC2+FIAjPFlAFjjSwAwx6cHYI9PDaAQnxZAJT4lgFJ8OgC1+FQAivFpAFTjUwAox4cHUI8PDeAQHxbAJT4kgFN8OAC3+FAAjvFhAFzjQwA4x08HcI+fDlB/Xw9wd/TT9d7h0IazGffpyz47IH0HfEafgSAdHwZgvJAfEOTjQwF8Q7CIDwcwXlA9yG3GaVhv/X4Bq9+I/X6++IwFEG8YmqEAQvnigwsg3jA0QwGE8sUHF0C8YWiGAgjliw8ugHjD0AwFEMoXH1wA8YahGT4Ah47af/P0CvIAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.30b28979.svg";
export { ForwardRef as ReactComponent };